/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type BusinessCapacityWorkEntryPointComponent = EntryPointComponent<
	{},
	{},
	{},
	{
		tenantContext: TenantContext;
	}
>;

export const businessCapacityWorkEntryPoint: EntryPoint<
	BusinessCapacityWorkEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<BusinessCapacityWorkEntryPointComponent>(
		/* webpackChunkName: "async-business-capacity-work" */ './BusinessCapacityWorkEntryPoint.tsx',
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const { tenantContext } = entryPointRouteParams;

		return {
			queries: {},
			entryPoints: {},
			extraProps: {
				tenantContext,
			},
		};
	},
});
